/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from 'react'
import { type ModalActions } from '@store/modal.tsx'
type ModalState = {
	open: () => void
	close: () => void
	goTo: (step: ModalActions) => void
}

const ModalContext = createContext<ModalState>({
	open: () => {},
	close: () => {},
	goTo: (step: ModalActions) => step,
})

const useModal = () => useContext(ModalContext)

export { ModalContext, useModal }
export { type ModalState }
